import { Controller } from "@hotwired/stimulus";

// Submits the form a beat after the last keystroke, so a filter field applies as you
// type instead of waiting for Enter. Each submit is a round trip, hence the debounce.
// requestSubmit is deliberate: form.submit() skips the submit event, so Turbo would
// never see it and the frame navigation would become a full page load.
export default class extends Controller {
  static targets = ["clear"];
  static values = { delay: { type: Number, default: 250 } };

  connect() {
    this.syncClear();
  }

  disconnect() {
    this.cancel();
  }

  cancel() {
    clearTimeout(this.timeout);
  }

  submit() {
    this.syncClear();
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue);
  }

  // Toggling a control is one deliberate choice rather than a burst, so it skips the
  // debounce. It still cancels a pending keystroke submit, which would otherwise fire
  // straight after this one and repeat the same request.
  submitNow() {
    this.syncClear();
    clearTimeout(this.timeout);
    this.element.requestSubmit();
  }

  // These controls live outside the results frame, so a submit swaps the results and
  // leaves this row as the server last drew it. Every filter rests on a blank value, so
  // anything else checked, or anything typed, means there is something to clear.
  syncClear() {
    if (!this.hasClearTarget) return;

    const search = this.element.querySelector("input[type=search]");
    const filtered =
      (search && search.value.trim() !== "") ||
      this.element.querySelector('input[type=radio]:checked:not([value=""])') !== null;

    this.clearTarget.classList.toggle("hidden", !filtered);
  }
}
